import React from "react";

import { makeStyles, useTheme } from "@material-ui/core/styles";
import { Box, useMediaQuery } from "@material-ui/core";

const useStyles = makeStyles(theme => ({
	contactsHeader: {
		display: "flex",
		alignItems: "center",
		padding: "0px 6px 6px 6px",
		flexWrap: "wrap",
		gap: theme.spacing(1),
	},
	mobileHeader: {
		flexDirection: "column",
		alignItems: "stretch",
		padding: theme.spacing(1),
		"& > *:first-child": {
			textAlign: "center",
			marginBottom: theme.spacing(1),
		},
	},
}));

const MainHeader = ({ children }) => {
	const classes = useStyles();
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

	return (
		<Box className={`${classes.contactsHeader} ${isMobile ? classes.mobileHeader : ''}`}>
			{children}
		</Box>
	);
};

export default MainHeader;
